import axios from 'axios'
import { startCase, toLower } from 'lodash'

import { emptyAddress } from '../components/Address/AddressFields'
import { Address } from './address'

export interface DotNumberPayload {
  dotNumber: string
}

// todo @taylangocmen: refactor this to only type used properties
export type DotNumberResponsePayload = {
  dot_number: {
    allowedToOperate: string
    bipdInsuranceOnFile: string
    bipdInsuranceRequired: string
    bipdRequiredAmount: string
    bondInsuranceOnFile: string
    bondInsuranceRequired: string
    brokerAuthorityStatus: string
    cargoInsuranceOnFile: string
    cargoInsuranceRequired: string
    carrierOperation: {
      carrierOperationCode: string
      carrierOperationDesc: string
    }
    censusTypeId: {
      censusType: string
      censusTypeDesc: string
      censusTypeId: number
    }
    commonAuthorityStatus: string
    contractAuthorityStatus: string
    crashTotal: number
    dbaName: string
    dotNumber: number
    driverInsp: number
    driverOosInsp: number
    driverOosRate: number
    driverOosRateNationalAverage: string
    ein: number
    fatalCrash: number
    hazmatInsp: number
    hazmatOosInsp: number
    hazmatOosRate: number
    hazmatOosRateNationalAverage: string
    injCrash: number
    isPassengerCarrier: string
    issScore: null
    legalName: string
    mcs150Outdated: string
    oosDate: null
    oosRateNationalAverageYear: string
    phyCity: string
    phyCountry: string
    phyState: string
    phyStreet: string
    phyZipcode: string
    reviewDate: string
    reviewType: string
    safetyRating: string
    safetyRatingDate: string
    safetyReviewDate: string
    safetyReviewType: string
    snapshotDate: null
    statusCode: string
    totalDrivers: number
    totalPowerUnits: number
    towawayCrash: number
    vehicleInsp: number
    vehicleOosInsp: number
    vehicleOosRate: number
    vehicleOosRateNationalAverage: string
  }
  mc_number: {
    docketNumber: number
    docketNumberId: number
    dotNumber: number
    prefix: string
  }
}

export type DotAndMcNumber = {
  dotNumber?: DotNumberResponsePayload['dot_number']
  mcNumber?: DotNumberResponsePayload['mc_number']
}

export function parseDotNumber(dotResponse: DotNumberResponsePayload): DotAndMcNumber {
  return {
    dotNumber: dotResponse.dot_number,
    mcNumber: dotResponse.mc_number,
  }
}

export function getDotAndMcNumber({ dotNumber }: DotNumberPayload): Promise<DotAndMcNumber> {
  return axios
    .post(`/api/v3/fmcsa/dot-number/`, { dot_number: dotNumber })
    .then((response) => parseDotNumber(response.data))
}

export function getDotAddress(dotNumber: DotAndMcNumber['dotNumber']): Address {
  if (!dotNumber) return { id: '', country: '', ...emptyAddress }

  return {
    id: '',
    city: startCase(toLower(dotNumber.phyCity)),
    state: dotNumber.phyState,
    country: dotNumber.phyCountry,
    line1: dotNumber.phyStreet,
    line2: '',
    zip: dotNumber.phyZipcode?.split('-')[0],
  }
}
